export default __webpack_public_path__ + "static/media/classroom 2.c257e13e.JPG";